import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=541b8a42&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=js&"
export * from "./RoleCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=541b8a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b8a42",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText})


/* vuetify-loader */
import installDirectives from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541b8a42')) {
      api.createRecord('541b8a42', component.options)
    } else {
      api.reload('541b8a42', component.options)
    }
    module.hot.accept("./RoleCard.vue?vue&type=template&id=541b8a42&scoped=true&", function () {
      api.rerender('541b8a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/role/RoleCard.vue"
export default component.exports